function titleCaseUploadStatus(str: string) {
    return str.toLowerCase().split('_').map(word => (word.replace(word[0], word[0].toUpperCase()))).join(' ');
}

export default { titleCaseUploadStatus };